import { QrcodeProps } from "./types"
import React, { useMemo } from "react"
import { observer } from "mobx-react-lite"
import QrcodeSvg from "~/ui/qrcode-svg"
import styled from '~/ui/styled'
import { screen } from "~utils"
import { CenterFlex, ColumnFlex } from "~components/El"
const QR_SIDE_PADDING = 24
const QR_DEFAULT_SIZE = 180
const QR_MAX_SIZE = 200

const Section = styled(ColumnFlex)`
  margin-top: 16px;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
`
const QrcodeWrap = styled(CenterFlex)`
  position: relative;
  width: auto;
  max-width: 100%;
  padding: 0 ${QR_SIDE_PADDING / 2}px;
  box-sizing: border-box;
`
// const Overlay = styled.View`
//   position: absolute;
//   align-items: center;
//   justify-content: center;
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
// `
// const AvatarWrap = styled.View`
//   background-color: #fff;
//   box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
//   padding: 3px;
//   border-radius: ${8 * screen.vw}px;
// `
const Text = styled.Text`
  margin-top: 16px;
  padding: 0 ${QR_SIDE_PADDING / 2}px;
  color: #aaaaaa;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;
  max-width: 100%;
  box-sizing: border-box;
`

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Qrcode: React.FC<QrcodeProps> = ({ value, avatar, name, description, size }) => {
  const qrSize = useMemo(
    () =>
      size ??
      Math.min(
        QR_MAX_SIZE,
        Math.round(QR_DEFAULT_SIZE * Math.min(screen.vw, 1.1)),
      ),
    [size],
  )

  return (
    <Section>
      <QrcodeWrap>
        <QrcodeSvg value={value} size={qrSize} ecl={"M"} />
      </QrcodeWrap>
      {!!description && <Text>{description}</Text>}
    </Section>
  )
}

export default observer(Qrcode)
